import React from 'react';
import {
	StyledHeader,
	StyledContainer,
	StyledContainerHeader,
	StyledContainerContent,
	StyledBox,
	StyledBoxSocialMedia,
	StyledIconsCol,
} from './style';
import color from '../../../config/colors.json';
import CardWithoutMedia from '../../../components/Campanhas/CardWithoutMedia';
import Google from '../../../img/google.svg';
import Facebook from '../../../img/facebook.svg';
import Instagram from '../../../img/instagram.svg';
import Grafico from '../../../img/grafico.svg';
import { ReactComponent as Hand } from '../../../img/combinedshape.svg';
import CardWithTitle from '../../../components/Campanhas/CardWithTitle';

export default () => (
	<>
		<div style={{ padding: '32px 24px 34px 34px' }}>
			<div className="d-flex justify-content-between align-items-center">
				<StyledHeader>Mídias externas</StyledHeader>
			</div>
			<CardWithTitle
				icon={(<Hand fill={color.light} />)}
				title="Para você anunciar sua loja ou seus veículos no Google, Facebook e Instagram."
			>
				<StyledContainer>
					<StyledContainerHeader>
						Vantagens de anunciar nesses canais
					</StyledContainerHeader>
					<StyledContainerContent>
						<CardWithoutMedia
							plus="+"
							altIcon=""
							text="Amplie seu negócio e alcance suas metas comerciais."
							title="Visibilidade"
							classComponent="d-flex justify-content-between col-12 col-lg-4 col-xl-2 p-0"
						/>
						<CardWithoutMedia
							plus="+"
							altIcon=""
							text="Encontre novos clientes e crie uma relação duradoura com eles."
							title="Clientes"
							classComponent="d-flex justify-content-between col-12 col-lg-4 col-xl-2 p-0"
						/>

						<CardWithoutMedia
							plus="+"
							text="Impacte os compradores no momento em que eles pesquisarem o que você oferece."
							title="Oportunidades"
							classComponent="d-flex justify-content-between col-12 col-lg-4 col-xl-2 p-0"
						/>

						<CardWithoutMedia
							plus="+"
							text="Mostre sua loja e sua vitrine para um público altamente envolvido."
							title="Engajamento"
							classComponent="d-flex justify-content-between col-12 col-lg-4 col-xl-2 p-0"
						/>

						<CardWithoutMedia
							plus="+"
							text="Exiba suas ofertas para mais de 134 milhões de pessoas todos os dias."
							title="Vendas"
							classComponent="d-flex justify-content-between col-12 col-lg-4 col-xl-2 p-0"
						/>
					</StyledContainerContent>
				</StyledContainer>
			</CardWithTitle>
		</div>
		<StyledBox>
			<StyledBoxSocialMedia className="d-flex justify-content-between">
				<div className="container-fluid">
					<div className="row">
						<p>Planeja sua campanha <span className="textInfo">(em breve)</span></p>
						<div
							style={{
								width: '100%',
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
							}}
						>
							<StyledIconsCol bigScreenWidth="50%" smallScreenWidth="30%">
								<span>Aumente suas chances de fechar negócios anunciando em mais canais.</span>
							</StyledIconsCol>
							<StyledIconsCol bigScreenWidth="35%" smallScreenWidth="55%">
								<img src={Google} alt="" />
								<img src={Facebook} alt="" />
								<img src={Instagram} alt="" />
							</StyledIconsCol>
							<StyledIconsCol hideOnSmall bigScreenWidth="0%" />
						</div>
					</div>
				</div>
			</StyledBoxSocialMedia>
			<StyledBoxSocialMedia className="d-flex justify-content-between">
				<div className="container-fluid">
					<div className="row">
						<p>Se interessou?</p>
						<div className="row">
							<div className="col-xs-12 col-md-7 mb-4 mb-md-0">
								<span>
									Em breve essa funcionalidade está disponível para a sua loja.
									Deixe seu contato que te avisaremos.
								</span>
							</div>
							<div
								className="col-xs-12 col-md-5 align-self-end p-0"
								style={{ display: 'flex', justifyContent: 'center' }}
							>
								<div style={{ width: '177px' }}>
									<a href="https://www.surveygizmo.com/s3/5835721/M-dias-externas">
										Tenho interesse
										<img src={Grafico} alt="" style={{ width: '18px', height: '18px', marginLeft: '12px' }} />
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</StyledBoxSocialMedia>
		</StyledBox>
	</>
	);
